'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _translationUtils = require('@wix/photography-client-lib/dist/src/utils/translationUtils');

var _translationUtils2 = _interopRequireDefault(_translationUtils);

var _businessPackage = require('../../../assets/images/fullscreen-store/business-package.svg');

var _businessPackage2 = _interopRequireDefault(_businessPackage);

var _info = require('../../../assets/images/fullscreen-store/info.svg');

var _info2 = _interopRequireDefault(_info);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpgradeToBusinessPopup = function (_Component) {
  (0, _inherits3.default)(UpgradeToBusinessPopup, _Component);

  function UpgradeToBusinessPopup() {
    (0, _classCallCheck3.default)(this, UpgradeToBusinessPopup);
    return (0, _possibleConstructorReturn3.default)(this, (UpgradeToBusinessPopup.__proto__ || (0, _getPrototypeOf2.default)(UpgradeToBusinessPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(UpgradeToBusinessPopup, [{
    key: 'onCloseClick',
    value: function onCloseClick() {
      var closePopup = this.props.closePopup;

      closePopup();
    }
  }, {
    key: 'onUpgradePlanClick',
    value: function onUpgradePlanClick() {
      var businessPlanUrl = this.props.businessPlanUrl;

      window.open(businessPlanUrl, '_blank');
    }
  }, {
    key: 'getUserContent',
    value: function getUserContent() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-content' },
        _react2.default.createElement(
          'div',
          { className: 'cp-image' },
          _react2.default.createElement('img', { src: _businessPackage2.default })
        ),
        _react2.default.createElement(
          'div',
          { className: 'cp-title' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_Title')
        ),
        _react2.default.createElement(
          'div',
          { className: 'cp-subtitle' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_Text')
        ),
        _react2.default.createElement(
          'button',
          { className: 'cp-button', onClick: function onClick() {
              return _this2.onUpgradePlanClick();
            }, target: '_blank' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_CTA_Primary')
        ),
        _react2.default.createElement(
          'button',
          { className: 'cp-secondary-button', onClick: function onClick() {
              return _this2.onCloseClick();
            }, target: '_blank' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_CTA_Secondary')
        )
      );
    }
  }, {
    key: 'getUouContent',
    value: function getUouContent() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-content cp-content-uou' },
        _react2.default.createElement(
          'div',
          { className: 'cp-info-icon' },
          _react2.default.createElement('img', { src: _info2.default })
        ),
        _react2.default.createElement(
          'div',
          { className: 'cp-title' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_Title')
        ),
        _react2.default.createElement(
          'div',
          { className: 'cp-subtitle' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_Text')
        ),
        _react2.default.createElement(
          'button',
          { className: 'cp-secondary-button', onClick: this.onCloseClick.bind(this), target: '_blank' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_CTA')
        )
      );
    }
  }, {
    key: 'getCloseIcon',
    value: function getCloseIcon() {
      var _this3 = this;

      return _react2.default.createElement(
        'svg',
        {
          className: 'cp-x-button',
          onClick: function onClick() {
            return _this3.onCloseClick();
          },
          xmlns: 'http://www.w3.org/2000/svg',
          width: '12',
          height: '12',
          viewBox: '0 0 15 15'
        },
        _react2.default.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M15 .6l-.6-.6-6.9 6.9L.6 0 0 .6l6.9 6.9L0 14.4l.6.6 6.9-6.9 6.9 6.9.6-.6-6.9-6.9'
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewMode = _props.viewMode,
          isMobile = _props.isMobile;


      return _react2.default.createElement(
        'div',
        { className: 'artstore-popup-message-element ' + (isMobile ? 'artstore-popup-message-element-mobile' : '') },
        this.getCloseIcon(),
        viewMode === 'site' ? this.getUouContent() : this.getUserContent()
      );
    }
  }]);
  return UpgradeToBusinessPopup;
}(_react.Component);

exports.default = UpgradeToBusinessPopup;